export default ({
  namespaced: true,
  state: {
    view: 'company',
    data: []
  },
  getters: {
    data: state => {
      return state.data
    }
  },
  mutations: {
    data (state, payload) {
      state.data = payload
    },
    dataInsert (state, payload) {
      state.data.push(payload)
    },
    dataEdit (state, payload) {
      Object.assign(state.data[payload.index], payload.register)
    },
    dataDelete (state, payload) {
      state.data.splice(payload, 1)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/company.js